import React from 'react';
import { twMerge } from 'tailwind-merge';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Icon from 'components/icon/icon';
import Typography from 'components/typography/typography';

export type ToastProps = {
  title: string;
  description: string;
  variant: 'success' | 'error';
  className?: string;
};

export const Toast = (props: ToastProps): JSX.Element => {
  const containerClassNames = twMerge('flex gap-x-2', props.className);
  const iconClassNames = twMerge(
    props.variant === 'success' && 'text-primary',
    props.variant === 'error' && 'text-tomato-red',
  );

  return (
    <div className={containerClassNames}>
      <Icon
        className={iconClassNames}
        icon={props.variant === 'success' ? 'circle-checked' : 'circle-checked'}
      />
      <div className="flex flex-col gap-y-2">
        <div className="flex justify-between items-center">
          <Typography as="p" variant="body-large-bold">
            {props.title}
          </Typography>
        </div>
        <Typography as="p" variant="body-medium" className="text-gray500">
          {props.description}
        </Typography>
      </div>
    </div>
  );
};

type ShowToastHandler = (
  options: Omit<ToastProps, 'className' | 'variant'>,
) => void;

export const showSuccessToast: ShowToastHandler = (options): void => {
  toast(
    <Toast
      variant="success"
      title={options.title}
      description={options.description}
    />,
    {
      progressClassName: '!bg-primary',
      progressStyle: {
        background: 'none',
      },
    },
  );
};

export const showErrorToast: ShowToastHandler = (options): void => {
  toast(
    <Toast
      variant="error"
      title={options.title}
      description={options.description}
    />,
    {
      progressClassName: '!bg-tomato-red',
      progressStyle: {
        background: 'none',
      },
    },
  );
};
